module.exports = __webpack_public_path__ + "static/media/citrus_color_gray.cc7172c9.svg";